import {
  getApi,
  postApi,
  putApi,
} from '@services/agent-foundation/agent-foundation-api-service';

export function getEnvironments(queryParams?: Record<string, any>) {
  const apiUrl = '/agent-garden/environments';
  const queryString = queryParams
    ? `?${Object.entries(queryParams)
      .flatMap(([key, value]) => {
        if (value === undefined || value === null) {
          return [];
        }
        if (Array.isArray(value)) {
          return value.map(
            (v) => `${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`,
          );
        }
        return [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`];
      })
      .join('&')}`
    : '';
  return getApi(`${apiUrl}${queryString}`);
}

/**
 * Process raw getEnvironments API response into a normalized shape with
 * data.environments and runtime names mapped from runtime_name to name.
 */
// get runtime data

export function getAgentPackages(runtimeId: string) {
  const apiUrl = `/runtimes/${runtimeId}`;
  return getApi(apiUrl);
}

export function linkRuntimeToIntegrationEnvironment(
  integrationEnvironmentId: string,
  runtimeId: string,
) {
  const apiUrl = '/agent-garden/environments';
  const payload = {
    integration_environment_id: integrationEnvironmentId,
    runtimes: runtimeId ? [{ runtime_id: runtimeId }] : [],
  };
  return postApi(apiUrl, payload);
}
/**
 * Configure runtime for an Agent Garden environment.
 * PUT /api/v1/environments/{ag_env_id}
 * Body: { runtimes: [{ runtime_id: "runtime-uuid" }] }
 */
export function updateEnvironmentRuntime(
  agEnvId: string,
  payload: { runtimes: Array<{ runtime_id: string }> },
) {
  const apiUrl = `/agent-garden/environments/${agEnvId}`;
  return putApi(apiUrl, payload);
}
/**
 * Set an Agent Garden environment as the default.
 * PUT /environments/{ag_env_id} with body { is_default: true }
 */
export function setEnvironmentAsDefault(agEnvId: string) {
  const apiUrl = `/agent-garden/environments/${agEnvId}`;
  return putApi(apiUrl, { is_default: true });
}
